module.exports = __webpack_public_path__ + "static/media/RP-71.36ceb951.pdf";